import PostRow from "./PostRow";
import LoadingComponent from "./LoadingComponent";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { fetchPost, loadingSet } from "../store/actions/postActions";
import Swal from "sweetalert2";

export default function PostTable() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { posts, loading } = useSelector((state) => state.posts);

	useEffect(() => {
		dispatch(fetchPost())
			.catch((err) => {
				return Swal.fire({
					icon: "error",
					title: "Error",
					text: err,
				});
			})
			.finally(() => {
				dispatch(loadingSet(false));
			});
	}, []);

	const toAddPostPage = () => {
		navigate("/posts/new-post");
	};

	return (
		<>
			<div className="d-flex align-items-center justify-content-between">
				<h2 className="mb-3">News List</h2>
				<button onClick={toAddPostPage} type="button" className="btn btn-dark">
					Create new post
				</button>
			</div>
			<div className="table-responsive">
				{loading && <LoadingComponent />}
				{!loading && (
					<table className="table table-hover">
						<thead>
							<tr className="text-center table-light">
								<th>No</th>
								<th>Title</th>
								<th>Content</th>
								<th>Image Url</th>
								<th>Category</th>
								<th>Author</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{!loading &&
								posts.map((post, index) => <PostRow post={post} index={index} key={post.id} />)}
						</tbody>
					</table>
				)}
			</div>
		</>
	);
}
